import { MyRoutes } from "../../interfaces/interfaces";

import {
  ACCOUNT_DASHBOARD,
  ATTENDANCE,
  BRANCH_STORE,
  BRANCH_STORE_DASHBOARD,
  CC_ADMIN_DASHBOARD,
  CC_AGENT,
  CC_AGENT_DASHBOARD,
  CC_CAMPAIGN,
  CC_LEAD_POOL,
  CRM_ADMIN_KEY,
  DC_DASHBOARD,
  DC_DIAGNOSIS,
  DNT_DASHBOARD,
  DNT_DIAGNOSIS,
  DOCUMENTS,
  DYNAMIC_TEMPLATE,
  EMP_MANAGEMENT,
  FORM_BUILDER,
  HR_DASHBOARD,
  IMPORT_UTILITY,
  INS_MASTERS,
  INVENTORY_ITEM_MASTERS,
  INVENTORY_MASTER_TABLE,
  INVENTORY_REQUEST,
  INVENTORY_UNIT_TYPE_MAP,
  INVOICE,
  IPD_CREATE_CASE,
  IPD_ID,
  IPD_INVOICE,
  LAB_CONFIGURATION,
  LAB_DASHBOARD,
  LAB_INVOICE,
  LAB_JOB,
  LAB_REQUEST,
  LEAVE_MANAGEMENT,
  MAIN_STORE,
  MAIN_STORE_DASHBOARD,
  MANAGE_MASTER_TABLE,
  MANAGE_STAFF,
  MANAGE_USER_ROLE,
  MASTER_IMPORT,
  MC_ADMIN_DASHBOARD,
  MC_DASHBOARD,
  MOB_APP_CONFIGURATION,
  ONGING_CLAIMS,
  PATIENT_EMR,
  PAYROLL,
  PHARMACY_MAIN_STORE,
  PHARMACY_POS,
  PHARMACY_STORE,
  PURCHASE_INVOICE,
  RADIOLOGY_CONFIGURAION,
  RADIOLOGY_DASHBOARD,
  RADIOLOGY_INVOICE,
  RADIOLOGY_JOB,
  RADIOLOGY_REQUEST,
  RECEIPT,
  RECEP_DASHBOARD,
  REPORTS,
  REPORT_BUILDER,
  REPORT_GENERATOR,
  REPORT_MAPPING,
  SCHEDULAR,
  SER_MASTERS,
  UNAVAILABILITY,
  UPAY_CONFIG,
  VIEW_APPOINTMENT,
  VIEW_CHART_OF_ACCOUNTS,
  VOUCHERS,
} from "../../config/modules";

import {
  LazyMobileAppConfigLayout,
  LazyOtpVerfication,
  LazyQuestionnaireSubmit,
  LazyRecoveryPassword,
  LazySubmitOtp,
  LazySubmitQuestionnaireForm,
  LazySubmitQuestionnaireLayout,
} from "./lazyLoadFiles";

import * as lazy from "./lazyLoadFiles";
import ViewAppointmentpage from "../../pages/viewAppointment/viewAppointment";

export const commonRoutes: any[] = [
  {
    path: "/",
    element: (
      <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
        <lazy.LazyLandingPage />
      </lazy.ErrorBoundaryHoc>
    ),
    children: [
      {
        path: "",
        element: <lazy.Login />,
        children: [],
        header: "",
        location: "/",
      },
      {
        path: "forgotpassword",
        element: <lazy.ForgotPassword />,
        children: [],
        header: "",
        location: "/forgotpassword",
      },
      {
        path: "otpverfication",
        element: <LazyOtpVerfication />,
        children: [],
        header: "",
        location: "/otpverfication",
      },
      {
        path: "resetpassword",
        element: <LazyRecoveryPassword />,
        children: [],
        header: "",
        location: "/resetpassword",
      },
      {
        path: "contactus",
        element: <lazy.ContactUS />,
        children: [],
        header: "",
        location: "/contactus",
      },
    ],
    header: "",
    location: "/",
  },
  {
    path: "submitquestionnairelayout",
    element: (
      <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
        <LazySubmitQuestionnaireLayout />
      </lazy.ErrorBoundaryHoc>
    ),
    children: [
      {
        path: "",
        element: <LazySubmitQuestionnaireForm />,
        children: [],
        header: "",
        location: "/submitquestionnairelayout",
      },
      {
        path: "questionnairesubmit",
        element: <LazyQuestionnaireSubmit />,
        children: [],
        header: "",
        location: "/submitquestionnairelayout/questionnairesubmit",
      },
    ],
    header: "",
    location: "/submitquestionnairelayout",
  },
  {
    path: "dynamicformsubmitLayout",
    element: <lazy.DynamicFormLayout />,
    children: [
      {
        path: "",
        element: <lazy.DynamicFormSubmit />,
        children: [],
        header: "",
        location: "/dynamicformsubmitLayout",
      },
    ],
    header: "",
    location: "/dynamicformsubmitLayout",
  },
  {
    path: "submitotp",
    element: (
      <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
        <LazySubmitOtp />
      </lazy.ErrorBoundaryHoc>
    ),
    children: [],
    header: "",
    location: "/submitotp",
  },
  {
    path: "privacy-policy",
    element: <lazy.PrivacyPolicy />,
    children: [],
    header: "",
    location: "/privacy-policy",
  },
  {
    path: "privacy-policy-promed-staff",
    element: <lazy.StaffPrivacyPolicy />,
    children: [],
    header: "",
    location: "/privacy-policy-promed-staff",
  },
];

export const authRoutes: any[] = [
  {
    path: "/*",
    element: (
      <lazy.AuthWrapper>
        <lazy.MainLayout />
      </lazy.AuthWrapper>
    ),
    children: [
      // mc admin routes
      {
        id: MOB_APP_CONFIGURATION,
        path: "mobileappconfiguration/*",
        element: <LazyMobileAppConfigLayout />,
        children: [
          {
            path: "appointment",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.MobileAppAppointment />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Mobile App Configurations",
            location: "/mobileappconfiguration/appointment",
            roles: ["MC Admin"],
          },
          {
            path: "news",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.MobileAppNews />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Mobile App Configurations",
            location: "/mobileappconfiguration/news",
            roles: ["MC Admin"],
          },
        ],
        header: "Mobile App Configurations",
        location: "/mobileappconfiguration",
        roles: ["MC Admin"],
      },
      {
        id: MC_ADMIN_DASHBOARD,
        path: "admin-dashbord/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.MCAdminDashbord />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.MCAdminDashbord />,
            children: [],
            header: "Admin dashboard",
            location: "/admin-dashbord",
            roles: ["MC Admin"],
          },
        ],
        header: "Medical Center AdmindashBoard",
        location: "/admin-dashbord",
        roles: ["MC Admin"],
      },
      {
        id: MANAGE_STAFF,
        path: "manageusers/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.ManageUsersLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.ManageUsers />,
            children: [],
            header: "Manage Staff",
            location: "/manageusers",
            roles: ["MC Admin"],
          },
          {
            path: "createusers/*",
            element: <lazy.CreateUsers />,
            children: [
              {
                path: "primary",
                element: <lazy.CreateUserPrimary />,
                children: [],
                header: "Manage Staff",
                location: "/manageusers/createusers/primary",
                roles: ["Super Admin"],
              },
              {
                path: "secondary",
                element: <lazy.CreateUserSecondary />,
                children: [],
                header: "Manage Staff",
                location: "/manageusers/createusers/secondary",
                roles: ["Super Admin"],
              },
            ],
            header: "Add Medical Center Users",
            location: "/manageusers/createusers",
            roles: ["Super Admin"],
          },
        ],
        header: "Manage Staff",
        location: "/manageusers",
        roles: ["MC Admin"],
      },
      {
        id: MANAGE_MASTER_TABLE,
        path: "mastertablemanagenew/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.ManageMasterTableNewtLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.ManageMasterTableNewtLayout />,
            children: [],
            header: "Manage Master Tables - Manage Category",
            location: "/mastertablemanagenew",
            roles: ["MC Admin"],
          },
          {
            path: "managemasternew",
            element: <lazy.ManageMasterNew />,
            children: [],
            header: "Manage Master Tables - Manage Category",
            location: "/mastertablemanagenew/managemasternew",
            roles: ["MC Admin"],
          },
          {
            path: "manageappoinmentstatus",
            element: <lazy.ManageAppoinmentStatus />,
            children: [],
            header: "Manage Master Tables - Appoinment Status",
            location: "/mastertablemanagenew/manageappoinmentstatus",
            roles: ["MC Admin"],
          },
          {
            path: "managecategoryvalues",
            element: <lazy.ManageCategoryValues />,
            children: [],
            header: "Manage Master Tables - Manage Category Value",
            location: "/mastertablemanagenew/managecategoryvalues",
            roles: ["MC Admin"],
          },
          {
            path: "manageappoinmentstatus",
            element: <lazy.ManageAppoinmentStatus />,
            children: [],
            header: "Manage Master Tables - Appoinment Status",
            location: "/mastertablemanagenew/manageappoinmentstatus",
            roles: ["MC Admin"],
          },

          {
            path: "manageassigntag",
            element: <lazy.ManageAssignTag />,
            children: [],
            header: "Manage Master Tables - Manage Assign Tag",
            location: "/mastertablemanagenew/manageassigntag",
            roles: ["MC Admin"],
          },
          {
            path: "manageinventorytype",
            element: <lazy.ManageInventoryUnitType />,
            children: [],
            header: "Manage Master Tables - Manage Inventory Type",
            location: "/mastertablemanagenew/manageinventorytype",
            roles: ["MC Admin"],
          },
          {
            path: "managepaymentmode",
            element: <lazy.ManagePaymentModes />,
            children: [],
            header: "Manage Master Tables - Manage Payment Modes",
            location: "/mastertablemanagenew/managepaymentmode",
            roles: ["MC Admin"],
          },
        ],
        header: "Manage Master Tables",
        location: "/mastertablemanage",
        roles: ["MC Admin"],
      },
      {
        id: MANAGE_USER_ROLE,
        path: "usergroups/*",
        element: <lazy.ManageUserGroupsLayout />,
        children: [
          {
            path: "",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.UserGroupList />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Manage User Roles",
            location: "/usergroups",
            roles: ["MC Admin"],
          },
          {
            path: "manageusergroups/*",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.ManageUserGroup />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [
              {
                path: "primary",
                element: <lazy.PrimaryUserGroup />,
                children: [],
                header: "Manage User Roles",
                location: "/manageusergroups/usergroups",
                roles: ["MC Admin"],
              },
              {
                path: "secondary",
                element: <lazy.SecondaryUsergroup />,
                children: [],
                header: "Manage User Roles",
                location: "/manageusergroups/usergroups/secondary",
                roles: ["MC Admin"],
              },
            ],
            header: "Manage User Roles",
            location: "/usergroups/manageusergroups",
            roles: ["MC Admin"],
          },
        ],
        header: "Manage User Roles",
        location: "/usergroup",
        roles: ["MC Admin"],
      },
      {
        id: MC_DASHBOARD,
        path: "medicalcenter/*",
        element: <lazy.DashboardLayout />,
        children: [
          {
            path: "branch",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.MedicalCenterBranch />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [
              {
                path: "",
                element: <lazy.BranchList />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/branch",
                roles: ["Medical Center Admin"],
              },
              {
                path: "managebranch",
                element: <lazy.ManageBranch />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/branch/managebranch",
                roles: ["Medical Center Admin"],
              },
            ],
            header: "Manage Medical Center Setup",
            location: "/medicalcenter/branch",
            roles: ["Medical Center Admin"],
          },
          {
            path: "department",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.MedicalCenterDepartment />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [
              {
                path: "",
                element: <lazy.DepartmentList />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/department",
                roles: ["Medical Center Admin"],
              },
              {
                path: "managedepartment",
                element: <lazy.ManageDepartment />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/department/managedepartment",
                roles: ["Medical Center Admin"],
              },
              {
                path: "managespecialities",
                // element: <ManageSpecialities />,
                element: <lazy.ManageSpecialitiesNew />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/department/managespecialities",
                roles: ["Medical Center Admin"],
              },
            ],
            header: "Manage Medical Center Setup",
            location: "/medicalcenter/department",
            roles: ["Medical Center Admin"],
          },
          {
            path: "ward",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.MedicalCenterWard />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [
              {
                path: "",
                element: <lazy.WardList />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/ward",
                roles: ["Medical Center Admin"],
              },
              {
                path: "manageward",
                element: <lazy.ManageWard />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/ward/manageward",
                roles: ["Medical Center Admin"],
              },
            ],
            header: "Manage Medical Center Setup",
            location: "/medicalcenter/ward",
            roles: ["Medical Center Admin"],
          },
          {
            path: "room",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.MedicalCenterRoom />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [
              {
                path: "",
                element: <lazy.RoomList />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/room",
                roles: ["Medical Center Admin"],
              },
              {
                path: "manageroom",
                element: <lazy.ManageRoom />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/room/manageroom",
                roles: ["Medical Center Admin"],
              },
            ],
            header: "Manage Medical Center Setup",
            location: "/medicalcenter/room",
            roles: ["Medical Center Admin"],
          },
          {
            path: "bed",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.MedicalCenterBed />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [
              {
                path: "",
                element: <lazy.BedList />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/bed",
                roles: ["Medical Center Admin"],
              },
              {
                path: "managebed",
                element: <lazy.ManageBed />,
                children: [],
                header: "Manage Medical Center Setup",
                location: "/medicalcenter/bed/managebed",
                roles: ["Medical Center Admin"],
              },
            ],
            header: "Manage Medical Center Setup",
            location: "/medicalcenter/bed",
            roles: ["Medical Center Admin"],
          },
        ],
        header: "Medical Center - Branch Setup",
        location: "/medicalcenter/branch",
        roles: ["Super Admin"],
      },
      {
        id: INS_MASTERS,
        path: "insurancemaster",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.InsuranceMaster />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [],
        header: "Insurance Masters",
        location: "/insurancemaster",
        roles: ["Medical Center Admin"],
      },
      {
        id: ONGING_CLAIMS,
        path: "ongoing-claims",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.OnGoingClaims />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [],
        header: "Insurance Claims",
        location: "/ongoing-claims",
        roles: ["Medical Center Admin"],
      },
      {
        id: SER_MASTERS,
        path: "services",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.Services />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [],
        header: "Services Masters",
        location: "/services",
        roles: ["Medical Center Admin"],
      },
      {
        id: INVENTORY_MASTER_TABLE,
        path: "inventorymastertable/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.InventoryMasterTableLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.InventoryMasterTable />,
            children: [],
            header: "Supplier Master",
            location: "/inventorymastertable",
            roles: ["Medical Center Admin"],
          },
          {
            path: "addnewsuplier",
            element: <lazy.AddNewSuplier />,
            children: [],
            header: "Add New Supplier",
            location: "/addnewsuplier",
            roles: ["Medical Center Admin"],
          },
        ],
        header: "Supplier Master ",
        location: "/inventorymastertable",
        roles: ["Medical Center Admin"],
      },
      {
        id: INVENTORY_ITEM_MASTERS,
        path: "inventoryitemtable/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.InventoryItemTableLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.InventoryItemTable />,
            children: [],
            header: "Inventory Item Tables",
            location: "/inventoryitemtable",
            roles: ["Medical Center Admin"],
          },
          {
            path: "addnewitem",
            element: <lazy.AddNewItem />,
            children: [],
            header: "Add New Item",
            location: "/addnewitem",
            roles: ["Medical Center Admin"],
          },
        ],
        header: "Inventory Item Tables",
        location: "/inventoryitemtable",
        roles: ["Medical Center Admin"],
      },

      {
        id: MASTER_IMPORT,
        path: "master-import/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.MasterImport />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [],
        header: "Master Import",
        location: "/master-import",
        roles: ["Super Admin"],
      },
      // Unit Type Master
      {
        id: INVENTORY_UNIT_TYPE_MAP,
        path: "unitTypeMap/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.UnitTypeMainLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [],
        header: "Unit Type Master",
        location: "/unitTypeMap",
        roles: ["Medical Center Admin"],
      },

      // receptionist routes

      {
        id: VIEW_APPOINTMENT,
        path: "viewappointment",
        element: <ViewAppointmentpage />,
        header: "View Appointment",
        children: [],
        location: "/viewappointment",
        roles: ["View Appointment"],
      },
      {
        id: RECEP_DASHBOARD,
        path: "receptionist/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.Receptionist />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [],
        header: "Receptionist",
        location: "/receptionist",
        roles: ["Receptionist"],
      },
      {
        id: PATIENT_EMR,
        path: "patientemr/*",
        element: <lazy.PatientEmrLayout />,
        children: [
          {
            path: "",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.PatientEmrDashboard />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Patient EMR Dashboard",
            location: "/patientemr",
            roles: ["MC Admin"],
          },
          {
            path: "sharequestionnaireemail",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.ShareQuestionEmail />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Patient Emr Dashboard",
            location: "patientemr/sharequestionnaireemail",
            roles: ["MC Admin"],
          },
          {
            path: "questionnaire-form-pdf",
            element: (
              <lazy.QuestionnaireFormPdf />
              // <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
              //   <lazy.QuestionnaireFormPdf />
              // </lazy.ErrorBoundaryHoc>
            ),
            header: "Questionnaire Form",
            location: "patientemr/questionnaire-form-pdf",
            roles: ["MC Admin"],
          },
        ],
        header: "Patient Emr Dashboard",
        location: "/patientemr",
        roles: ["MC Admin"],
      },

      // for viewAppointment
      // {
      //   // id: DC_DASHBOARD,
      //   path: "appointment/*",
      //   element: <lazy.ViewAppointment />,
      //   children: [],
      //   header: "Appointment ",
      //   location: "/viewAppointment",
      //   roles: ["Appointment"],
      // },

      {
        id: SCHEDULAR,
        path: "schedular/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.MainSchedular />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.BookingSchedularFunctional />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Manage Appointments",
            location: "/schedular",
            roles: ["MC Admin"],
          },
          {
            path: "beds",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.BedSchedular />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Manage Appointments",
            location: "/schedular/beds",
            roles: ["MC Admin"],
          },
          {
            path: "nurse",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.BookingSchedularFunctional />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Patient Emr Dashboard",
            location: "/schedular/nurse",
            roles: ["MC Admin"],
          },
          {
            path: "room",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.RoomSchedular />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Manage Appointments",
            location: "/schedular/room",
            roles: ["MC Admin"],
          },
        ],
        header: "Manage Appointments",
        location: "/bookingappointment",
        roles: ["Recessepnoist"],
      },
      {
        id: INVOICE,
        path: "invoice/*",
        element: <lazy.InvoiceLayout />,
        children: [
          {
            path: "",
            element: <lazy.InvoiceLayout />,
            children: [],
            header: "Invoice",
            location: "/invoice/information",
            roles: ["Super Admin"],
          },
          {
            path: "information",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.InvoiceInformation />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Invoice",
            location: "/invoice/information",
            roles: ["Super Admin"],
          },
          {
            path: "services",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.InvoiceServices />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Invoice - Services",
            location: "/invoice/services",
            roles: ["Super Admin"],
          },
          {
            path: "payment",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.InvoicePayment />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Invoice - Payment",
            location: "/invoice/payment",
            roles: ["Super Admin"],
          },
        ],
        header: "Invoice",
        location: "/invoice",
        roles: ["Super Admin"],
      },
      {
        id: RECEIPT,
        path: "receipt/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.ReceiptLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.Receipt />,
            children: [],
            header: "Receipt",
            location: "/receipt",
            roles: ["Receptionist"],
          },
        ],
        header: "Receipt",
        location: "/receipt",
        roles: ["Receptionist"],
      },
      // doctor routes
      {
        id: DC_DASHBOARD,
        path: "doctor/*",
        element: <lazy.DoctorAppointmentDashboard />,
        children: [],
        header: "Doctor",
        location: "/doctor",
        roles: ["DOCTOR"],
      },
      {
        id: DC_DIAGNOSIS,
        path: "patientdiagnosis/*",
        element: <lazy.DoctorDiagnosisLayout />,
        children: [
          {
            path: "diagnosis",
            element: <lazy.DiagnosisForm />,
            children: [],
            header: "Diagnosis",
            location: "/patientdiagnosis/diagnosis",
            roles: ["DOCTOR"],
          },
          {
            path: "medication",
            element: <lazy.Medication />,
            children: [],
            header: "Medication",
            location: "/patientdiagnosis/medication",
            roles: ["DOCTOR"],
          },
          {
            path: "request",
            element: <lazy.Request />,
            children: [],
            header: "Request",
            location: "/patientdiagnosis/request",
            roles: ["DOCTOR"],
          },
          {
            path: "referral",
            element: <lazy.Referral />,
            children: [],
            header: "Referral",
            location: "/patientdiagnosis/referral",
            roles: ["DOCTOR"],
          },
          {
            path: "treatment",
            element: <lazy.TreatmentPlanList />,
            children: [],
            header: "Treatment",
            location: "/patientdiagnosis/treatment",
            roles: ["DOCTOR"],
          },
          {
            path: "invoices",
            element: <lazy.Invoice />,
            children: [],
            header: "Doctor",
            location: "/patientdiagnosis/invoices",
            roles: ["DOCTOR"],
          },
        ],
        header: "Doctor Diagnosis",
        location: "/diagnosis",
        roles: ["DOCTOR"],
      },
      {
        id: FORM_BUILDER,
        path: "formBuilder/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.CreateNewFormsLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.CreateNewFormList />,
            children: [],
            header: "Create New Forms",
            location: "",
            roles: ["DOCTOR"],
          },
          {
            path: "createNewFormBuilder",
            element: <lazy.CreateNewFormBuilder />,
            children: [],
            header: "Create New Form Builder",
            location: "/createNewFormBuilder",
            roles: ["DOCTOR"],
          },
          {
            path: "*",
            element: <lazy.NotFound />,
            children: [],
            header: "Page Not Found",
            roles: ["DOCTOR"],
          },
        ],
        header: "Create New Forms",
        location: "/formBuilder",
        roles: ["DOCTOR"],
      },

      {
        id: SCHEDULAR,
        path: "schedular/*",
        element: <lazy.MainSchedular />,
        children: [
          {
            path: "",
            element: <lazy.BookingSchedularFunctional />,
            children: [],
            header: "Manage Appointments",
            location: "/schedular",
            roles: ["MC Admin"],
          },
          {
            path: "beds",
            element: <lazy.BedSchedular />,
            children: [],
            header: "Manage Appointments",
            location: "/schedular/beds",
            roles: ["MC Admin"],
          },
          {
            path: "nurse",
            element: <lazy.BookingSchedularFunctional />,
            children: [],
            header: "Patient Emr Dashboard",
            location: "/schedular/nurse",
            roles: ["MC Admin"],
          },
        ],
        header: "Manage Appointments",
        location: "/bookingappointment",
        roles: ["Recessepnoist"],
      },
      // lab routes
      {
        id: LAB_DASHBOARD,
        path: "dashboard",
        element: <lazy.LabDashboard />,
        children: [],
        header: "Lab Dashboard",
        location: "/dashboard",
        roles: ["Super Admin"],
      },
      {
        id: LAB_JOB,
        path: "job/*",
        element: <lazy.JobLayout />,
        children: [
          // {
          //   path: "",
          //   element: <lazy.JobLayout />,
          //   children: [],
          //   header: "Job",
          //   location: "/job/createjobs",
          //   roles: ["Super Admin"],
          // },
          // {
          //   path: "createjobs",
          //   element: <lazy.CreateJobs />,
          //   children: [],
          //   header: "Job",
          //   location: "/job/createjobs",
          //   roles: ["LAB_SUPERVISOR"],
          // },
          {
            path: "viewJobs",
            element: <lazy.ViewJobs />,
            children: [],
            header: "View Jobs",
            location: "/job/viewJobs",
            roles: ["Super Admin"],
          },
        ],
        header: "Job",
        location: "/job/viewJobs",
        roles: ["LAB_SUPERVISOR"],
      },
      {
        id: LAB_REQUEST,
        path: "request/*",
        element: <lazy.LabRequestLayout />,
        children: [
          {
            path: "",
            element: <lazy.LabRequest />,
            children: [],
            header: "Lab Request",
            location: "/request",
            roles: ["LAB_SUPERVISOR"],
          },
        ],
        header: "Lab Request",
        location: "/request",
        roles: ["LAB_SUPERVISOR"],
      },
      {
        id: LAB_INVOICE,
        path: "invoice/*",
        element: <lazy.LabInvoiceLayout />,
        children: [
          {
            path: "",
            element: <lazy.LabInvoiceLayout />,
            children: [],
            header: "Lab Invoice",
            location: "/invoice/labinformation",
            roles: ["Super Admin"],
          },
          {
            path: "labinformation",
            element: <lazy.LabInformation />,
            children: [],
            header: "Lab Invoice",
            location: "/invoice/labinformation",
            roles: ["Super Admin"],
          },
          {
            path: "labservices",
            element: <lazy.LabServices />,
            children: [],
            header: "Lab Services",
            location: "/invoice/labservices",
            roles: ["Super Admin"],
          },
          {
            path: "labpayment",
            element: <lazy.LabPayment />,
            children: [],
            header: "Lab Payment",
            location: "/labinvoice/labpayment",
            roles: ["Super Admin"],
          },
        ],
        header: "Lab",
        location: "/invoice",
        roles: ["Super Admin"],
      },
      {
        id: LAB_CONFIGURATION,
        path: "configuration/*",
        element: <lazy.Configuration />,
        children: [],
        header: "Configuration",
        location: "/configuration",
        roles: ["LAB_SUPERVISOR"],
      },

      // Radiology Routes
      {
        id: RADIOLOGY_DASHBOARD,
        path: "dashboard",
        element: <lazy.RadiologyDashboard />,
        children: [],
        header: "Radiology Dashboard",
        location: "/dashboard",
        roles: ["RADIOLOGY_SUPERVISOR"],
      },
      {
        id: RADIOLOGY_JOB,
        path: "radiology-job/*",
        element: <lazy.RadiologyJobLayout />,
        children: [
          // {
          //   path: "",
          //   element: <lazy.RadiologyJobLayout />,
          //   children: [],
          //   header: "Job",
          //   location: "/radiology-job/createjobs",
          //   roles: ["Super Admin"],
          // },
          // {
          //   path: "createjobs",
          //   element: <lazy.RadiologyCreateJobs />,
          //   children: [],
          //   header: "Job",
          //   location: "/radiology-job/createjobs",
          //   roles: ["Super Admin"],
          // },
          {
            path: "viewJobs",
            element: <lazy.RadiologyViewJobs />,
            children: [],
            header: "View Jobs",
            location: "/radiology-job/viewJobs",
            roles: ["Super Admin"],
          },
        ],
        header: "Job",
        location: "/radiology-job/viewJobs",
        roles: ["RADIOLOGY_SUPERVISOR"],
      },
      {
        id: RADIOLOGY_REQUEST,
        path: "radiology-request/*",
        element: <lazy.RadioLogyRequestLayout />,
        children: [
          {
            path: "",
            element: <lazy.RadiologyRequest />,
            children: [],
            header: "Radiology Request",
            location: "/radiology-request",
            roles: ["RADIOLOGY_SUPERVISOR"],
          },
        ],
        header: "Radiology Request",
        location: "/radiology-request",
        roles: ["RADIOLOGY_SUPERVISOR"],
      },
      {
        id: RADIOLOGY_INVOICE,
        path: "radiology-invoice/*",
        element: <lazy.RadiologyInvoiceLayout />,
        children: [
          {
            path: "",
            element: <lazy.RadiologyInvoiceLayout />,
            children: [],
            header: "Invoice",
            location: "/radiology-invoice/information",
            roles: ["RADIOLOGY_SUPERVISOR"],
          },
          {
            path: "information",
            element: <lazy.RadiologyInvoiceInformation />,
            children: [],
            header: "Invoice",
            location: "/radiology-invoice/information",
            roles: ["RADIOLOGY_SUPERVISOR"],
          },
          {
            path: "services",
            element: <lazy.RadiologyInvoiceService />,
            children: [],
            header: "Invoice - Services",
            location: "/radiology-invoice/services",
            roles: ["RADIOLOGY_SUPERVISOR"],
          },
          {
            path: "payment",
            element: <lazy.RadiologyInvoicePayment />,
            children: [],
            header: "Invoice - Payment",
            location: "/radiology-invoice/payment",
            roles: ["RADIOLOGY_SUPERVISOR"],
          },
        ],
        header: "Invoice",
        location: "/radiology-invoice",
        roles: ["RADIOLOGY_SUPERVISOR"],
      },
      {
        id: RADIOLOGY_CONFIGURAION,
        path: "radiology-configuration/*",
        element: <lazy.RadiologyConfiguration />,
        children: [],
        header: "Configuration",
        location: "/radiology-configuration",
        roles: ["RADIOLOGY_SUPERVISOR"],
      },

      // Inventory Routes
      {
        id: INVENTORY_REQUEST,
        path: "request/*",
        element: <lazy.RequestLayout />,
        children: [
          {
            path: "",
            element: <lazy.InventoryRequest />,
            children: [],
            header: "Request",
            location: "/request",
            roles: ["Super Admin"],
          },
        ],
        header: "request",
        location: "/request",
        roles: ["Super Admin"],
      },
      {
        id: BRANCH_STORE_DASHBOARD,
        path: "dashboard",
        element: <lazy.BranchStoreDashbopard />,
        children: [],
        header: "BranchStoreDashboard",
        location: "/dashboard",
        roles: ["Super Admin"],
      },
      {
        id: BRANCH_STORE,
        path: "branchstore/*",
        element: <lazy.BranchStoreLayout />,
        children: [
          {
            path: "",
            element: <lazy.BranchStore />,
            children: [],
            header: "Branch Store",
            location: "/branchstore",
            roles: ["Super Admin"],
          },
        ],
        header: "Branch Store",
        location: "/branchstore",
        roles: ["Super Admin"],
      },
      {
        id: MAIN_STORE_DASHBOARD,
        path: "dashboard",
        element: <lazy.MainStoreDashboard />,
        children: [],
        header: "MainStoreDashboard",
        location: "/dashboard",
        roles: ["Super Admin"],
      },
      {
        id: MAIN_STORE,
        path: "mainstore/*",
        element: <lazy.MainStoreLayout />,
        children: [
          {
            path: "",
            element: <lazy.MainStore />,
            children: [],
            header: "Main Store",
            location: "/mainstore",
            roles: ["Super Admin"],
          },
        ],
        header: "Mainstore",
        location: "/mainstore",
        roles: ["Super Admin"],
      },
      {
        id: PHARMACY_MAIN_STORE,
        path: "pharmacymainstore/*",
        element: <lazy.MainStoreLayout />,
        children: [
          {
            path: "",
            element: <lazy.MainStore />,
            children: [],
            header: "Pharmacy main Store",
            location: "/pharmacymainstore",
            roles: ["Super Admin"],
          },
        ],
        header: "Pharmacy",
        location: "/pharmacymainstore",
        roles: ["Super Admin"],
      },
      {
        id: PURCHASE_INVOICE,
        path: "purchaseinvoice/*",
        element: <lazy.PurchaseInvoiceLayout />,
        children: [
          {
            path: "",
            element: <lazy.PurchaseInvoice />,
            children: [],
            header: "Purchase Invoice",
            location: "/purchaseinvoice",
            roles: ["Super Admin"],
          },
        ],
        header: "Purchaseinvoice",
        location: "/purchaseinvoice",
        roles: ["Super Admin"],
      },

      // dentist routes

      {
        id: DNT_DASHBOARD,
        path: "dentist/*",
        element: <lazy.DentistAppointmentDashboard />,
        children: [],
        header: "Dentist",
        location: "/dentist",
        roles: ["DENTIST"],
      },
      {
        id: DNT_DIAGNOSIS,
        path: "patientdentaldiagnosis/*",
        element: <lazy.DentistDiagnosisLayout />,
        children: [
          {
            path: "diagnosis",
            element: <lazy.DentalDiagnosisForm />,
            children: [],
            header: "Diagnosis",
            location: "/patientdentaldiagnosis/diagnosis",
            roles: ["DENTIST"],
          },
          {
            path: "medication",
            element: <lazy.DentalMedication />,
            children: [],
            header: "Medication",
            location: "/patientdentaldiagnosis/medication",
            roles: ["DENTIST"],
          },
          {
            path: "request",
            element: <lazy.DentalRequest />,
            children: [],
            header: "Request",
            location: "/patientdentaldiagnosis/request",
            roles: ["DENTIST"],
          },
          {
            path: "referral",
            element: <lazy.DentalReferral />,
            children: [],
            header: "Referral",
            location: "/patientdentaldiagnosis/referral",
            roles: ["DENTIST"],
          },
          {
            path: "treatment",
            element: <lazy.DentalTreatmentPlanList />,
            children: [],
            header: "Treatment",
            location: "/patientdentaldiagnosis/treatment",
            roles: ["DENTIST"],
          },
        ],
        header: "Dentist Diagnosis",
        location: "/diagnosis",
        roles: ["DENTIST"],
      },

      // pharmacy route
      {
        id: PHARMACY_STORE,
        path: "dashboard",
        element: <lazy.PharmacyDashboard />,
        children: [],
        header: "Pharmacy Dashboard",
        location: "/dashboard",
      },
      {
        id: PHARMACY_POS,
        path: "pharmacy/*",
        element: <lazy.PharmacyLayout />,
        children: [
          {
            path: "pharmacy-info",
            element: <lazy.PharmacyInfoForm />,
            children: [],
            header: "POS",
            location: "/pharmacy/pharmacy-info",
            roles: ["MC Admin"],
          },
          {
            path: "pharmacy-payment",
            element: <lazy.PharmacyPaymentNew />,
            children: [],
            header: "POS",
            location: "/pharmacy/pharmacy-info",
            roles: ["MC Admin"],
          },
          {
            path: "pharmacy-onhold",
            element: <lazy.PharmacyOnhold />,
            children: [],
            header: "POS",
            location: "/pharmacy/pharmacy-onhold",
            roles: ["MC Admin"],
          },
        ],
        header: "Pharmacy",
        location: "/pharmacy",
        roles: ["Pharmacy"],
      },
      {
        id: PHARMACY_STORE,
        path: "pharmacystore",
        element: <lazy.PharmacyStore />,
        children: [],
        header: "Pharmacy Store",
        location: "/pharmacystore",
      },
      {
        id: "public",
        path: "*",
        element: <lazy.NotFound />,
        children: [],
        header: "Page Not Found",
        roles: ["MC Admin"],
      },
      {
        id: "public",
        path: "notfound",
        element: <lazy.NotFound />,
        children: [],
        header: "Page Not Found",
        roles: ["MC Admin"],
      },
      {
        id: "public",
        path: "notpermitted",
        element: <lazy.NotFound />,
        children: [],
        header: "Page Not Found",
        roles: ["MC Admin"],
      },

      // IPD routes
      {
        id: IPD_ID,
        path: "ipd/*",
        element: <lazy.IPD />,
        children: [
          {
            path: "",
            element: <lazy.IpdDashboard />,
            children: [],
            header: "IPD",
            location: "/ipd",
            roles: ["DOCTOR"],
          },
        ],
        header: "IPD",
        location: "/ipd",
        roles: ["DOCTOR"],
      },

      {
        id: IPD_CREATE_CASE,
        path: "createipdmainlayout/*",
        element: <lazy.CreateIpdMainLayout />,
        children: [
          {
            path: "consultation",
            element: <lazy.Consultation />,
            children: [],
            header: "IPD",
            location: "/createipdmainlayout/consultation",
            roles: ["DOCTOR"],
          },
        ],
        header: "IPD",
        location: "/createipdmainlayout",
        roles: ["DOCTOR"],
      },

      // Receptionist IPD Routes
      {
        id: IPD_INVOICE,
        path: "ipd-invoice/*",
        element: <lazy.IpdInvoiceLayout />,
        children: [
          {
            path: "",
            element: <lazy.IpdInvoiceLayout />,
            children: [],
            header: "Ipd Invoice",
            location: "/ipd-invoice",
            roles: ["Super Admin"],
          },
          {
            path: "patientinfo",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.PatientIPDInfo />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Ipd Invoice",
            location: "/ipd-invoice/patientinfo",
            roles: ["Super Admin"],
          },
          {
            path: "consumble",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.PatientConsumble />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Patient Consumble",
            location: "/ipd-invoice/consumble",
            roles: ["Super Admin"],
          },
          {
            path: "charges",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.PatientCharges />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Patient Charges",
            location: "/ipd-invoice/charges",
            roles: ["Super Admin"],
          },
          {
            path: "services",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.PatientIPDServices />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Patient Services",
            location: "/ipd-invoice/services",
            roles: ["Super Admin"],
          },

          {
            path: "payment",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.PatientPayment />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Patient Payment",
            location: "/ipd-invoice/payment",
            roles: ["Super Admin"],
          },
        ],
        header: "Ipd Invoice",
        location: "/ipd-invoice",
        roles: ["Super Admin"],
      },
      {
        id: IPD_CREATE_CASE,
        path: "ipd-case-form",
        element: <lazy.IpdCreateForm isRecep={true} />,
        children: [],
        header: "IPD",
        location: "/ipd-case-form",
        roles: ["RECEPTIONIST"],
      },
      // Call Center Admin Routes
      {
        id: CC_ADMIN_DASHBOARD,
        path: "call/*",
        element: <lazy.CallCenterDashboardLayout />,
        children: [
          {
            path: "",
            element: <lazy.Call />,
            children: [],
            header: "Call Center Admin",
            location: "/call",
            roles: ["Medical Center Admin"],
          },
        ],
        header: "Call Center Admin",
        location: "/call",
        roles: ["Super Admin"],
      },
      {
        id: CC_LEAD_POOL,
        path: "lead/*",
        element: <lazy.LeadLayout />,
        children: [
          {
            path: "leads",
            element: <lazy.Leads />,
            children: [],
            header: "Lead Pool",
            location: "/lead/leads",
            roles: ["Medical Center Admin"],
          },
          {
            path: "internal",
            element: <lazy.Internal />,
            children: [],
            header: "Lead Pool",
            location: "/lead/internal",
            roles: ["Medical Center Admin"],
          },
          {
            path: "external",
            element: <lazy.External />,
            children: [],
            header: "Lead Pool ",
            location: "lead/external",
            roles: ["Medical Center Admin"],
          },
        ],
        header: "Proact",
        location: "/lead",
        roles: ["Super Admin"],
      },
      {
        id: CC_AGENT,
        path: "agents/*",
        element: <lazy.AgentsLayout />,
        children: [
          {
            path: "",
            element: <lazy.Agents />,
            children: [],
            header: "Agents",
            location: "/agents",
            roles: ["Medical Center Admin"],
          },
        ],
        header: "Agents",
        location: "/agents",
        roles: ["Super Admin"],
      },
      {
        id: CC_CAMPAIGN,
        path: "campaigns/*",
        element: <lazy.CampaignsLayout />,
        children: [
          {
            path: "onGoingCampaigns",
            element: <lazy.OnGoingCampaigns />,
            children: [],
            header: "Campaigns",
            location: "campaigns/onGoingCampaigns",
            roles: ["Medical Center Admin"],
          },
          {
            path: "createCampaigns",
            element: <lazy.CreateCampaigns />,
            children: [],
            header: "Campaigns",
            location: "campaigns/createCampaigns",
            roles: ["Medical Center Admin"],
          },
        ],
        header: "Campaigns",
        location: "/campaigns",
        roles: ["Super Admin"],
      },

      //call center Agent
      {
        id: CC_AGENT_DASHBOARD,
        path: "agent/*",
        element: <lazy.AgentDashboardLayout />,
        children: [
          {
            path: "agentleads",
            element: <lazy.AgentLeads />,
            children: [],
            header: "Leads",
            location: "/agent/agentleads",
            roles: ["Medical Center Admin"],
          },

          {
            path: "follow-up",
            element: <lazy.FollowUp />,
            children: [],
            header: "Follow Up",
            location: "/agent/follow-up",
            roles: ["Medical Center Admin"],
          },
        ],
        header: "Call Center Agent",
        location: "/agent",
        roles: ["Super Admin"],
      },
      {
        id: CRM_ADMIN_KEY,
        path: "crmadmin/*",
        element: <lazy.CrmAdminLayout />,
        children: [
          {
            path: "new",
            element: <lazy.CrmNew />,
            children: [],
            header: "CRM Admin",
            location: "/crmadmin/new",
            roles: ["Medical Center Admin"],
          },
          {
            path: "sent",
            element: <lazy.CrmSent />,
            children: [],
            header: "CRM Admin",
            location: "/crmadmin/sent",
            roles: ["Medical Center Admin"],
          },
        ],
        header: "Crm Admin",
        location: "/crmadmin",
        roles: ["Super Admin"],
      },
      {
        id: REPORT_GENERATOR,
        path: "reportgenerator",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.ReportBuilder />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [],
        header: "Report Generator",
        location: "/reportgenerator",
      },
      {
        id: REPORT_BUILDER,
        path: "reportbuilder/*",
        element: <lazy.ReportBuilderLayout />,
        children: [
          {
            path: "",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.ReportBuilderList />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Report Builder",
            location: "/reportbuilder",
            roles: ["MC Admin"],
          },
          {
            path: "createreport",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.CreateReport />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Report Builder",
            location: "/reportbuilder/createreport",
            roles: ["MC Admin"],
          },
        ],
        header: "Report Builder",
        location: "/reportbuilder",
        roles: ["Medical Center Admin"],
      },
      // report mapping
      {
        id: REPORT_MAPPING,
        path: "report-mapping/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.ReportMapping />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [],
        header: "Report Mapping",
        location: "/report-mapping",
        roles: ["MC Admin"],
      },
      // HL7
      {
        id: REPORT_BUILDER,
        path: "hl7/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.HL7Layout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.HL7List />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "HL7",
            location: "/hl7",
            roles: ["MC Admin"],
          },
          {
            path: "createhl7",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.CreateHL7 />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "HL7",
            location: "/hl7/createhl7",
            roles: ["MC Admin"],
          },
        ],
        header: "HL7",
        location: "/hl7",
        roles: ["MC Admin"],
      },
      // HR dashboard

      {
        id: HR_DASHBOARD,
        path: "hr-dashboard/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.HRDashboardLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.HrDashboard />,
            children: [],
            header: "Dashboard",
            location: "/hr-dashboard",
            roles: ["HR Admin"],
          },
          {
            path: "departments",
            element: <lazy.Departments />,
            children: [],
            header: "Departments",
            location: "/hr-dashboard/departments",
            roles: ["Super Admin"],
          },
        ],
        header: "Dashboard",
        location: "/hr-dashboard",
        roles: ["Super Admin"],
      },

      // HR Employee

      {
        id: EMP_MANAGEMENT,
        path: "employees/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.EmployeesLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.Employees />,
            children: [],
            header: "Employees",
            location: "/employees",
            roles: ["Super Admin"],
          },
          {
            path: "addEmployee",
            element: <lazy.AddEmployee />,
            children: [],
            header: "Add New Employee",
            location: "/employees/addEmployee",
            roles: ["Super Admin"],
          },
        ],
        header: "Employees",
        location: "/employees",
        roles: ["Super Admin"],
      },

      // HR Documents
      {
        id: DOCUMENTS,
        path: "documents/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.DocumentsLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.Documents />,
            children: [],
            header: "Documents",
            location: "/documents",
            roles: ["Super Admin"],
          },
          {
            path: "addnew",
            element: <lazy.AddDocument />,
            children: [],
            header: "Add New Document",
            location: "/documents/addnew",
            roles: ["Super Admin"],
          },
        ],
        header: "Documents",
        location: "/documents",
        roles: ["Super Admin"],
      },

      // HR Payroll
      {
        id: PAYROLL,
        path: "payroll/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.PayrollLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.Payroll />,
            children: [],
            header: "Payroll",
            location: "/payroll",
            roles: ["Super Admin"],
          },
          {
            path: "create",
            element: <lazy.Create />,
            children: [],
            header: "Create Salary Slip",
            location: "/payroll/create",
            roles: ["Super Admin"],
          },
          {
            path: "services",
            element: <lazy.EndofServices />,
            children: [],
            header: "End Of Services",
            location: "/payroll/services",
            roles: ["Super Admin"],
          },
          {
            path: "services/new",
            element: <lazy.New />,
            children: [],
            header: "Add New",
            location: "/payroll/services/new",
            roles: ["Super Admin"],
          },
        ],
        header: "Payroll",
        location: "/payroll",
        roles: ["Super Admin"],
      },

      // HR Attendance
      {
        id: ATTENDANCE,
        path: "attendance/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.AttendaceLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          // {
          //   path: '',
          //   element: <Attendance />,
          //   children: [],
          //   header: 'Attendance',
          //   location: '/attendance',
          //   roles: ['Super Admin'],
          // },
          {
            path: "",
            element: <lazy.ManageAttendance />,
            children: [],
            header: "Attendance",
            location: "/attendance/manage-attendance",
            roles: ["Super Admin"],
          },
        ],
        header: "Attendance",
        location: "/attendance",
        roles: ["Super Admin"],
      },

      // HR Leave
      {
        id: LEAVE_MANAGEMENT,
        path: "leave-management/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.LeaveManagementLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.LeaveManagement />,
            children: [],
            header: "Leave Management",
            location: "/leave-management",
            roles: ["Super Admin"],
          },
          {
            path: "leave-encashment",
            element: <lazy.LeaveEncashment />,
            children: [],
            header: "Leave Encashment",
            location: "/leave-management/leave-encashment",
            roles: ["Super Admin"],
          },
          {
            path: "leave-encashment/leave-formdata",
            element: <lazy.LeaveFormData />,
            children: [],
            header: "Leave Encashment",
            location: "/leave-management/leave-encashment/leave-formdata",
            roles: ["Super Admin"],
          },
          {
            path: "apply-leave",
            element: <lazy.ApplyLeave />,
            children: [],
            header: "Leave Management",
            location: "/leave-management/apply-leave",
            roles: ["Super Admin"],
          },
        ],
        header: "Leave Management",
        location: "/leaveManagement",
        roles: ["Super Admin"],
      },

      // Account Dashboard
      {
        id: ACCOUNT_DASHBOARD,
        path: "account-dashboard/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.AccountDashboardLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.Dashboard />,
            children: [],
            header: "Dashboard",
            location: "/account-dashboard",
            roles: ["Super Admin"],
          },
        ],
        header: "Dashboard",
        location: "/dashboard",
        roles: ["Super Admin"],
      },

      // View chart of accounts
      {
        id: VIEW_CHART_OF_ACCOUNTS,
        path: "viewchartofaccounts/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.ViewChartOfAccountsLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.ViewChartOfAccountsLayout />,
            children: [],
            header: "View chart of accounts",
            location: "/viewchartofaccounts",
            roles: ["Super Admin"],
          },
          {
            path: "level2list",
            element: <lazy.Level2List />,
            children: [],
            header: "View chart of accounts",
            location: "/viewchartofaccounts/level2list",
            roles: ["Super Admin"],
          },
          {
            path: "level3list",
            element: <lazy.Level3List />,
            children: [],
            header: "View chart of accounts",
            location: "/viewchartofaccounts/level3list",
            roles: ["Super Admin"],
          },
          {
            path: "level4list",
            element: <lazy.Level4List />,
            children: [],
            header: "View chart of accounts",
            location: "/viewchartofaccounts/level4list",
            roles: ["Super Admin"],
          },
          {
            path: "level5list",
            element: <lazy.Level5List />,
            children: [],
            header: "View chart of accounts",
            location: "/viewchartofaccounts/level5list",
            roles: ["Super Admin"],
          },
        ],
        header: "View Chart Of Accounts",
        location: "/viewchartofaccounts",
        roles: ["Super Admin"],
      },

      // vouchers
      {
        id: VOUCHERS,
        path: "vouchers/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.VouchersLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.Vouchers />,
            children: [],
            header: "Vouchers",
            location: "/vouchers",
            roles: ["Super Admin"],
          },
        ],
        header: "Vouchers",
        location: "/vouchers",
        roles: ["Super Admin"],
      },

      // Account reports
      {
        id: REPORTS,
        path: "reports/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.ReportsLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "ledger",
            element: <lazy.Ledger />,
            children: [],
            header: "Reports - Ledger",
            location: "/reports/ledger",
            roles: ["Super Admin"],
          },
          {
            path: "trialbalance",
            element: <lazy.TrialBalance />,
            children: [],
            header: "Reports - Trial Balance",
            location: "/reports/trialbalance",
            roles: ["Super Admin"],
          },
          {
            path: "pl",
            element: <lazy.ProfitLoss />,
            children: [],
            header: "Reports - P & L",
            location: "/reports/pl",
            roles: ["Super Admin"],
          },
          {
            path: "balancesheet",
            element: <lazy.BalanceSheet />,
            children: [],
            header: "Reports - Balance Sheet",
            location: "/reports/balancesheet",
            roles: ["Super Admin"],
          },
        ],
        header: "Reports",
        location: "/reports",
        roles: ["Super Admin"],
      },

      // Manage Unavailability
      {
        id: UNAVAILABILITY,
        path: "unavailability/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.UnavailabilityLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.UnavailabilityLayout />,
            children: [],
            header: "Manage Unavailability",
            location: "/unavailability",
            roles: ["Super Admin"],
          },
          {
            path: "doctor",
            element: <lazy.DoctorUnavailablity />,
            children: [],
            header: "Manage Unavailability",
            location: "/unavailability/doctor",
            roles: ["Super Admin"],
          },
          {
            path: "rooms",
            element: <lazy.DoctorUnavailablity />,
            children: [],
            header: "Manage Unavailability",
            location: "/unavailability/room",
            roles: ["Super Admin"],
          },
        ],
        header: "Manage Unavailability",
        location: "/unavailability",
        roles: ["Super Admin"],
      },

      // UPAY Configuration
      // {
      //   id: UPAY_CONFIG,
      //   path: 'upay/*',
      //   element: (
      //     <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
      //       <UpayConfiguration />
      //     </lazy.ErrorBoundaryHoc>
      //   ),
      //   children: [],
      //   header: 'UPAY Configuration',
      //   location: '/upay',
      //   roles: ['Super Admin'],
      // },

      {
        id: UPAY_CONFIG,
        path: "configuration/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.Configurations />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "upay",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.UpayConfiguration />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Configuration",
            location: "configuration/upay",
            roles: ["Super Admin"],
          },
          {
            path: "whatsup",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.Whatsup />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Configuration",
            location: "configuration/whatsup",
            roles: ["Super Admin"],
          },
          {
            path: "wapi",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.Wapi />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Wapi-template",
            location: "configuration/wapi",
            roles: ["Super Admin"],
          },
          {
            path: "configuration-details",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.ConfigurationDetails />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Configuration",
            location: "configuration/configuration-details",
            roles: ["Super Admin"],
          },
          {
            path: "tax",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.TaxConfiguration />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Tax",
            location: "configuration/tax",
            roles: ["Super Admin"],
          },
          {
            path: "compliance",
            element: (
              <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
                <lazy.ComplianceDetails />
              </lazy.ErrorBoundaryHoc>
            ),
            children: [],
            header: "Compliance",
            location: "configuration/compliance",
            roles: ["Super Admin"],
          },
        ],
        header: "Configuration",
        location: "/configuration",
        roles: ["Super Admin"],
      },
      // Import utility
      {
        id: IMPORT_UTILITY,
        path: "import-utility/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.ImportUtility />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [],
        header: "Import Utility",
        location: "/import-utility",
        roles: ["Super Admin"],
      },

      // dynamic invoice template
      {
        id: DYNAMIC_TEMPLATE,
        path: "template/*",
        element: (
          <lazy.ErrorBoundaryHoc errorMessage="Something Went Wrong...">
            <lazy.DynamicTemplateLayout />
          </lazy.ErrorBoundaryHoc>
        ),
        children: [
          {
            path: "",
            element: <lazy.DynamicTemplate />,
            children: [],
            header: "Set template for invoice & receipt",
            location: "/template",
            roles: ["MC Admin"],
          },
          {
            path: "manage/*",
            element: <lazy.ManageDynamicTemplate />,
            children: [],
            header: "Set template for invoice & receipt",
            location: "/template/manage",
            roles: ["Super Admin"],
          },
        ],
        header: "Set template for invoice & receipt",
        location: "/template",
        roles: ["MC Admin"],
      },
    ],
    header: "Home",
    roles: ["MC Admin"],
  },
];

export const notFoundRoutes: MyRoutes[] = [
  ...commonRoutes,
  {
    path: "/*",
    element: (
      <lazy.AuthWrapper>
        <lazy.MainLayout />
      </lazy.AuthWrapper>
    ),
    children: [
      {
        path: "*",
        element: <lazy.NotFound />,
        children: [],
        header: "Page Not Found",
        roles: ["MC Admin"],
      },
      {
        path: "notfound",
        element: <lazy.NotFound />,
        children: [],
        header: "Page Not Found",
        roles: ["MC Admin"],
      },
      {
        path: "notpermitted",
        element: <lazy.NotFound />,
        children: [],
        header: "Page Not Found",
        roles: ["MC Admin"],
      },
    ],
    header: "Home",
    roles: ["MC Admin"],
  },
];

export const mainRouteData: MyRoutes[] = [...commonRoutes, ...authRoutes];
